<template>
  <span>
    <div
      v-if="srTransport === 'air'"
      :class="order.jyoSrType === 'twp'?'blue--text':'red--text'"
    >
      <i class="iconfont iconfeiji1 font-size-14" />
      {{ order.jyoSrType === 'twp'?'普貨':'特貨' }}
    </div>
    <div
      v-else-if="srTransport === 'se' && order.jyoShippingRate?.srLabel === 'HZKZQ' && order.jyoWhsAddrid === '1598'"
      class="amber--text"
    >
      <i class="iconfont iconchuan font-size-14" />
      海快
    </div>
    <div
      v-else-if="srTransport === 'se' && (order.jyoType==='7' || order.jyoType==='9') && order.jyoWhsAddrid !== '1592' && order.jyoWhsAddrid !== '1596'"
    >
      <svg
        class="svg-icon"
        aria-hidden="true"
      >
        <use xlink:href="#iconhaizhenkuai" />
      </svg>
      海真快
    </div>
    <div
      v-else-if="srTransport === 'se' && (order.jyoShippingRate?.srLabel?.startsWith('TBPDD'))"
      class="green--text"
    >
      <img
        src="/static/images/icon/tbpdd-rate.png"
        alt="淘拼專線"
        class="tbpddRateIcon"
        width="24"
        style="vertical-align: middle;"
      >
      海快
    </div>
    <div
      v-else-if="srTransport === 'se' && (order.jyoShippingRate?.srLabel === 'ECONOMY-ALL' || order.jyoWhsAddrid === '1598')"
      class="amber--text"
    >
      <i class="iconfont iconchuan font-size-14" />
      海快
    </div>
    <div
      v-else-if="order.jyoShippingRate?.srLabel?.startsWith('BIZECO')"
      class="orange--text"
    >
      <i class="iconfont iconchuan font-size-14" />
      海快
    </div>
    <div
      v-else-if="srTransport === 'se' || order.oid[0] === 'S'"
      class="green--text"
    >
      <i class="iconfont iconchuan font-size-14" />
      海快
    </div>
    <div
      v-else-if="srTransport === 'sea'"
      class="sea-color--text"
    >
      <i class="iconfont iconsea font-size-14" />
      海運
    </div>
  </span>
</template>
<script>
export default {
  props: {
    order: Object,
  },
  computed: {
    srTransport () {
      return this.order.jyoShippingRate?.transport || this.srTransport
    },
  },
}
</script>
